import Accordion from '@base/components/src/Accordion';
import FooterLinks from '../FooterLinks';
import { CompanyLinks, CustomerSupportLinks, ShippingServiceLinks } from './constants';

import styles from './FooterNavigation.module.css';
import { AccordionLinksProps } from './types';

const AccordionLink = ({ title, links }: AccordionLinksProps) => (
  <Accordion
    title={title}
    className={styles.footerAccordion}
    headerClassName={styles.footerAccordionHeader}
    titleClass={styles.footerAccordionTitle}
    contentClassName={styles.footerAccordionContent}
    hidePlusIcon
    iconClassName={styles.footerPlusIcon}
    rippleClassName={styles.footerRipple}
  >
    <FooterLinks links={links} />
  </Accordion>
);

const FooterNavigation = () => {
  return (
    <>
      <div className={styles.footerNavigationContainer}>
        <AccordionLink title={'Customer Support'} links={CustomerSupportLinks} />
        <AccordionLink title={'Shopping Services'} links={ShippingServiceLinks} />
        <AccordionLink title={'Get To Know Us'} links={CompanyLinks} />
      </div>

      <div className={styles.footerNavigation}>
        <div className={styles.footerNavigationSection}>
          <div className={styles.footerNavigationSectionTitle}>Customer Support</div>
          <FooterLinks links={CustomerSupportLinks} />
        </div>

        <div className={styles.footerNavigationSection}>
          <div className={styles.footerNavigationSectionTitle}>Shopping Services</div>
          <FooterLinks links={ShippingServiceLinks} />
        </div>

        <div className={styles.footerNavigationSection}>
          <div className={styles.footerNavigationSectionTitle}>Get To Know Us</div>
          <FooterLinks links={CompanyLinks} />
        </div>
      </div>
    </>
  );
};

export default FooterNavigation;
